<div class="pet-listings-container" dir="rtl">
  <!-- Header -->
  <header class="listings-header">
    <div class="header-content" (click)="navigateToPage()">
      <div class="header-icon">
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
          <path d="M12 21c-1.5 0-6-3.5-8-7.5C2 9 4 4 8.5 4c2 0 3 1.5 3.5 2.5C12.5 5.5 13.5 4 15.5 4 20 4 22 9 20 13.5 18 17.5 13.5 21 12 21z"/>
        </svg>
      </div>
      <div>
        <h2>חיות מחמד</h2>
        <!-- Count folded into the subtitle: it's passive information,
        so it belongs with the description rather than occupying
        its own pill alongside the real actions. -->
        <p class="subtitle">
          <span class="subtitle-text">מצא את החבר הכי טוב שלך</span>@if (pets.length) {
          <span
          class="subtitle-count">{{ pets.length }} מודעות</span>
        }
      </p>
    </div>
  </div>
  <div class="header-actions">
    @if (pets.length > 0) {
      <div class="scroll-arrows">
        <button class="arrow-btn" (click)="scrollLeft()" aria-label="מודעות חיות המחמד הבאות">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>
        </button>
        <button class="arrow-btn" (click)="scrollRight()" aria-label="מודעות חיות המחמד הקודמות">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
      </div>
    }
    <button type="button" class="view-all-btn" (click)="navigateToPage()">לכל המודעות</button>
  </div>
</header>

<!-- Loading State -->
@if (isLoading) {
  <div class="loading-state">
    <div class="pet-loader"><span></span><span></span><span></span></div>
    <p>טוען חיות מחמד...</p>
  </div>
}

<!-- Error State -->
@if (error && !isLoading) {
  <div class="error-state">
    <p>אופס! משהו השתבש</p>
    <button (click)="loadPets()" class="retry-btn">נסה שוב</button>
  </div>
}

<!-- Horizontal Scroll Track -->
@if (!isLoading && !error && pets.length > 0) {
  <div class="scroll-wrapper">
    <div class="pet-track" #petTrack dragScroll>
      @for (pet of pets; track pet; let i = $index) {
        <div
          class="pet-card"
          [style.animation-delay]="i * 80 + 'ms'"
          (click)="openPage(pet.id)"
          role="button"
          tabindex="0"
          [attr.aria-label]="'פתיחת מודעת חיית מחמד: ' + (pet.petName || pet.name)"
          (keydown.enter)="openPage(pet.id)"
          (keydown.space)="openPage(pet.id); $event.preventDefault()"
          >
          <!-- Internal (admin) ad linked to this category — generic layout, -->
          <!-- since it doesn't have any of the pet-specific fields below -->
          @if (isInternalAd(pet)) {
            <div class="card-image">
              <img
                [src]="pet.images?.[0]?.image || 'https://placehold.co/400x300/f0ebe3/c4a882?text=🐾'"
                [alt]="pet.name"
                (error)="onImageError($event)"
                />
              <div class="image-overlay">
                <span class="listing-badge">{{ pet.price ? '₪' + pet.price.toLocaleString() : 'ליצירת קשר' }}</span>
              </div>
            </div>
            <div class="card-body">
              <div class="card-header-row">
                <h3 class="pet-name">{{ pet.name }}</h3>
              </div>
              @if (pet.description) {
                <p class="internal-ad-desc">{{ pet.description }}</p>
              }
              @if (pet.city) {
                <div class="info-pills">
                  <span class="pill">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    {{ pet.city.nameHe }}
                  </span>
                </div>
              }
              <div class="card-footer">
                <div class="seller-info">{{ pet.userContactDetails?.contactPerson }}</div>
                <app-contact-menu
                  [phone]="pet.userContactDetails?.phoneNumber || ''"
                  [itemName]="pet.name"
                  [itemId]="pet.id"
                  [accentColor]="'#e8723a'"
                ></app-contact-menu>
              </div>
            </div>
          } @else {
            <!-- Image Section -->
            <div class="card-image">
              <img
                [src]="pet.images?.[0]?.image || 'https://placehold.co/400x300/f0ebe3/c4a882?text=🐾'"
                [alt]="pet.petName"
                (error)="onImageError($event)"
                />
              <div class="image-overlay">
                <span class="listing-badge" [class.free]="pet.freeAdoption">
                  {{ pet.freeAdoption ? 'אימוץ חינם' : (pet.price ? '₪' + pet.price.toLocaleString() : 'ליצירת קשר') }}
                </span>
                @if (pet.listingType?.label) {
                  <span class="type-badge">{{ pet.listingType.label }}</span>
                }
              </div>
              <!-- Optional fields (gender, age, size, breed, city...) can be empty on an
                   ad - every nested read is null-safe and an empty pill is not drawn. -->
              @if (pet.gender?.label) {
                <div class="gender-indicator" [class.male]="pet.gender.label === 'זכר'" [class.female]="pet.gender.label === 'נקבה'">
                  <span>{{ pet.gender.label === 'זכר' ? '♂' : '♀' }}</span>
                </div>
              }
              <app-card-biz-badges [item]="pet" [left]="44"></app-card-biz-badges>
            </div>
            <!-- Info Section -->
            <div class="card-body">
              <div class="card-header-row">
                <h3 class="pet-name">{{ pet.petName }}</h3>
                @if (pet.breed?.label) {
                  <span class="breed-label">{{ pet.breed.label }}</span>
                }
              </div>
              <div class="info-pills">
                @if (pet.age?.label) {
                  <span class="pill">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg>
                    {{ pet.age.label }}
                  </span>
                }
                @if (pet.city?.nameHe) {
                  <span class="pill">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
                    {{ pet.city.nameHe }}
                  </span>
                }
                @if (pet.size?.label) {
                  <span class="pill">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3v18M3 12h18"/></svg>
                    {{ pet.size.label }}
                  </span>
                }
                @if (pet.color) {
                  <span class="pill color-pill">
                    <span class="color-dot" [style.background]="getColorHex(pet.color)"></span>
                    {{ pet.color }}
                  </span>
                }
              </div>
              <div class="tags-row">
                @for (tag of (pet.suitability || []).slice(0, 4); track tag) {
                  <span
                    class="tag"
                    [class.highlight]="isHighlightTag(tag)"
                    >
                    {{ getTagIcon(tag) }} {{ tag }}
                  </span>
                }
                @if ((pet.suitability?.length || 0) > 4) {
                  <span class="tag more">
                    +{{ pet.suitability.length - 4 }}
                  </span>
                }
              </div>
              <div class="card-footer">
                <app-card-dealer [item]="pet"></app-card-dealer>
                <app-contact-menu
                  [phone]="pet.userContactDetails?.phoneNumber || ''"
                  [itemName]="pet.petName"
                  [itemId]="pet.id"
                  [accentColor]="'#e8723a'"
                ></app-contact-menu>
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
}

<!-- Empty State -->
@if (!isLoading && !error && pets.length === 0) {
  <div class="empty-state">
    <p>לא נמצאו חיות מחמד</p>
  </div>
}
</div>
